import React from 'react';
import { useSelector } from 'react-redux';
import Button from 'components/Button';
import { IconType } from 'components/Icon/constants';
import { projectFlatColors } from 'containers/BrandDefinition/selectors';
import style from './styles.module.scss';

const InteractiveCarouselButtonsElement: React.FC = () => {
  const FALLBACK_HEX_COLOR = '#2c6da4';
  const colors = useSelector(projectFlatColors);
  const primaryColor1 = colors.find(color => color.get('name') === 'PrimaryColor.1');
  const hexColor = primaryColor1?.get('HEX') ?? FALLBACK_HEX_COLOR;

  return (
    <div className={style.container}>
      <div>
        <Button
          icon={IconType.ARROW_LEFT_CAROUSEL}
          size='xxl'
          hexColor={hexColor}
        />
      </div>
      <div style={{ color: hexColor }}>#/#</div>
      <div>
        <Button
          icon={IconType.ARROW_RIGHT_CAROUSEL}
          size='xxl'
          hexColor={hexColor}
        />
      </div>
    </div>
  );
};

export default InteractiveCarouselButtonsElement;
